import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Eye } from 'lucide-react';

const IMPERSONATION_COOKIE_KEY = 'impersonationToken';
const IMPERSONATION_USER_KEY = 'impersonatedUser';

const ImpersonationBanner = () => {
  const navigate = useNavigate();

  // Read directly from storage - no hook needed for display-only
  const token = sessionStorage.getItem(IMPERSONATION_COOKIE_KEY);
  const storedUser = localStorage.getItem(IMPERSONATION_USER_KEY);

  if (!token || !storedUser) return null;

  let user;
  try {
    user = JSON.parse(storedUser);
  } catch {
    return null;
  }

  const handleExit = async () => {
    // Clear storage and redirect
    sessionStorage.removeItem(IMPERSONATION_COOKIE_KEY);
    localStorage.removeItem(IMPERSONATION_USER_KEY);
    navigate('/geniehireadmin/impersonate');
  };

  const roleLabel = user.user_type === 'Company_Admin' ? 'Org Admin' : 'HR';

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-600">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Eye className="w-5 h-5 text-white" />
          <span className="text-white text-sm font-medium">
            Viewing as (For Monitoring Only): <strong>{user.name}</strong>
            <span className="mx-2 text-white/70">|</span>
            <span className="text-white/90">{roleLabel}</span>
            {user.organization_name && (
              <>
                <span className="mx-2 text-white/70">|</span>
                <span className="text-white/90">{user.organization_name}</span>
              </>
            )}
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-2 px-4 py-1.5 bg-white/20 hover:bg-white/30 rounded-lg text-white text-sm font-medium transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
